var VERA = window.VERA || {};

// Initialize format functions immediately (not wrapped in DOM ready)
VERA.format = {
  percentageWhole: d3.format(".0%"),
  percentageTenth: d3.format(".1%"),
  money: d3.format("$,.0f"),
  number: d3.format(",.0f"),
  string: function (d) {
    return d;
  },
};
